import { render, staticRenderFns } from "./TeamInviteView.vue?vue&type=template&id=b8d57ffe&scoped=true"
import script from "./TeamInviteView.vue?vue&type=script&lang=js"
export * from "./TeamInviteView.vue?vue&type=script&lang=js"
import style0 from "./TeamInviteView.vue?vue&type=style&index=0&id=b8d57ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d57ffe",
  null
  
)

export default component.exports